import { DialogActions, DialogContent } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import {
    AreaNotification,
    ArrowLeftIcon,
    Button,
    FullScreenDialog,
    PageActionButton,
    RelodeTheme,
} from "@relode/core";
import * as React from "react";

import { useAddJobContext } from "../_infra";
import { AddJobStepsEnum } from "../types";
import { AddJobProps } from "./addJobProps";
import { Step1, Step2, Step3 } from "./steps";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {
                display: "flex",
                flexGrow: 1,
                flexDirection: "column",
            },
            shadow: {
                boxShadow: "2px -8px 8px -8px rgba(0, 0, 0, 0.2)",
                padding: theme.spacing(1),
                zIndex: 1,
                display: "flex",
                flexDirection: "column",
            },
            errorArea: {
                margin: theme.spacing(0, 3),
                marginBottom: 12,
            },
            saveAndExitButton: {
                marginTop: theme.spacing(1),
            },
        }),
    { name: "AddJobMobile" }
);

export const AddJobMobile = (props: AddJobProps) => {
    const classes = useStyles({});
    const {
        handleClose,
        handlePrevious,
        handleNext,
        handleSaveAndExit,
        activeStepId,
        handleFieldChange,
        handleButtonFieldChange,
    } = props;
    const {
        state: {
            ui: { isLoading, showOrderConfirmationStep },
        },
    } = useAddJobContext();

    const renderSteps = () => {
        switch (activeStepId) {
            case AddJobStepsEnum.Step1:
                return <Step1 handleFieldChange={handleFieldChange} />;
            case AddJobStepsEnum.Step2:
                return (
                    <Step2
                        handleFieldChange={handleFieldChange}
                        handleButtonFieldChange={handleButtonFieldChange}
                    />
                );
            case AddJobStepsEnum.Step3:
                return <Step3 />;
        }
    };
    return (
        <FullScreenDialog
            open={true}
            onClose={handleClose}
            title="add new job"
            isBusy={isLoading}
            classes={{
                content: classes.root,
            }}
            leftActions={
                activeStepId !== AddJobStepsEnum.Step1 ? (
                    <PageActionButton
                        id="backButton"
                        title="back to previous step"
                        color="primary"
                        onClick={handlePrevious}
                    >
                        <ArrowLeftIcon />
                    </PageActionButton>
                ) : null
            }
        >
            <DialogContent>
                {renderSteps()}
                <AreaNotification
                    areaName="wizardErrorArea"
                    className={classes.errorArea}
                />
            </DialogContent>

            <DialogActions disableSpacing className={classes.shadow}>
                <Button
                    id="next"
                    fullWidth
                    size="small"
                    color="primary"
                    variant="contained"
                    onClick={handleNext}
                >
                    {(activeStepId === AddJobStepsEnum.Step2 &&
                        !showOrderConfirmationStep) ||
                    activeStepId === AddJobStepsEnum.Step3
                        ? "finish"
                        : "next"}
                </Button>
                {handleSaveAndExit ? (
                    <Button
                        className={classes.saveAndExitButton}
                        id="saveAndExitButton"
                        fullWidth
                        size="small"
                        color="default"
                        variant="contained"
                        onClick={handleSaveAndExit}
                    >
                        save and exit
                    </Button>
                ) : null}
            </DialogActions>
        </FullScreenDialog>
    );
};
